<template>
  <div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { store } from '@/plugins/store';
import { AUTHENTICATION } from '@/store/mutation-types';
import { MENU } from '@/components/layout/store/mutation-types';
import { MENU_CLIENT_SWITCH_FOURNISSEUR } from '@/components/layout/store/state';

export default defineComponent({
    name: 'ChoixPortailClient',
    beforeMount() {
        store.commit(`authenticationState/${AUTHENTICATION.SET_PORTAIL}`, 'Client');
        let menu;
        if (localStorage.getItem('isFournisseur') === 'true' && localStorage.getItem('isClient') === 'true') {
            menu = MENU_CLIENT_SWITCH_FOURNISSEUR;
        }

        store.commit(`menuState/${MENU.SET_MENU}`, menu);
        store.commit(`menuState/${MENU.SET_CHOIX_MENU}`, 'client');
        this.$router.push('/dashboard');

    }
});
</script>

<style scoped>

</style>
